/*
 * Login action
 */

// General - App State related constants
export const START_QUESTION = 'START_QUESTION'
export const SHOW_ANSWER = 'SHOW_ANSWER'
export const SHOW_WAITING = 'SHOW_WAITING'
export const ANSWER_QUESTION = 'ANSWER_QUESTION'
export const SHOW_COMMERCIAL = 'SHOW_COMMERCIAL'
export const SHOW_VOUCHER_WINNER = 'SHOW_VOUCHER_WINNER'
export const SHOW_FINAL_RESULTS = 'SHOW_FINAL_RESULTS'
export const QUESTION_TIMER_FINISHED = 'QUESTION_TIMER_FINISHED'

export const QuizVersions = {
    CODE: 'CODE',
    REGULAR: 'REGULAR'
}

export const QuizStates = {
    QUESTION: 'QUESTION', // Question is visible
    ANSWER: 'ANSWER', // Answer is visible
    WAITING: 'WAITING', // Waiting for other players
    COMMERCIAL: 'COMMERCIAL',
    VOUCHER_WINNER: 'VOUCHER_WINNER'
}

/*
 * Login state setters 
 */
export function showWaitingScreen() {
    return { type: SHOW_WAITING }
}

export function startNextQuestion(question) {
    return { type: START_QUESTION, question: question }
} 

export function answerQuestion(question, answerId) {
    return { type: ANSWER_QUESTION, question: question, answered: true}
}

export function showAnswer(result) {
    return { type: SHOW_ANSWER, result: result }
}

export function showCommercial(result) {
    return { type: SHOW_COMMERCIAL, result: result }
}

export function showVoucherWinner(result) {
    return { type: SHOW_VOUCHER_WINNER, result: result }
}

export function setFinalResults(results) {
    return { type: SHOW_FINAL_RESULTS, result: results}
}

export function questionTimerFinished() {
    return { type: QUESTION_TIMER_FINISHED }
}



// WEBPACK FOOTER //
// ./src/components/store/actions/quiz.js